<!--<div style="width: 352px; flex: 1;" *ngIf="isLoading">-->
@if (isMinimized) {
  <div matTooltip="Expand Notes" class="tdo-notes-collapsed" data-cy="tdo-notes-collapsed">
    <div style="display: flex; flex-direction: column;" data-cy="tdo-notes-collapsed-icons">
      @if (!isDockedLeft) {
        <lucide-icon name="chevron-left" [size]="20" (click)="toggleSize(notesNormalSize)" data-cy="tdo-notes-expand-medium"></lucide-icon>
      }
      @if (isDockedLeft) {
        <lucide-icon name="chevron-right" [size]="20" data-cy="tdo-notes-right-chevron"></lucide-icon>
      }
      <div style="color: var(--tdo-primary-accent);" (click)="toggleSize(notesMaximunSize)" data-cy="tdo-notes-expand-full"><span class="material-symbols-outlined">
        keyboard_double_arrow_left
      </span>
    </div>
  </div>
</div>
}
@if (!isMinimized) {
  <div class="tdo-notes-main" [ngStyle]="{'width':currentSize}" style=" position: relative;" data-cy="tdo-notes-main-container">
    @if (isLoading) {
      <div style="width: 290px; flex: 1; position: absolute;" data-cy="tdo-notes-loading">
        <app-tdo-progress-spinner style="position: relative; top: 400px;"></app-tdo-progress-spinner>
      </div>
    }
    <div #filterDropdown (appClickOutside)="onFilterClickOutside()" [ngClass]="{'tdo-notes-filters-shown': isShowSettings, 'tdo-notes-filters-hidden': isShowSettings === false, 'tdo-notes-first-state': isShowSettings === undefined}" data-cy="tdo-notes-filters">
      <div style="display: flex; position: relative; top: 8px; cursor: pointer;" data-cy="tdo-notes-settings-header">
        <span style="flex: 1;" data-cy="tdo-notes-settings-title">Notes Settings</span>
        <!--<div *ngIf="!uiService.isNotesOnLeft" style="flex-basis: fit-content; font-size: 12px; text-decoration: underline;" (click)="onChangeNotesDock('left')">Dock Left</div>
        <div *ngIf="uiService.isNotesOnLeft" style="flex-basis: fit-content; font-size: 12px; text-decoration: underline;" (click)="onChangeNotesDock('right')">Dock Right</div>-->
      </div>
      <hr />
      <div style="font-weight: lighter;" data-cy="tdo-notes-filter-options">
        <span style="font-weight: 500; color: white;" data-cy="tdo-notes-filter-options-title">Filter options</span><br/>
        <div style="background-color: rgba(0,0,0,0.22); border-radius: 6px; color: white; padding: 3px 6px 3px 6px; font-weight: 400; border: 2px solid rgba(0,0,0,0.1);" data-cy="tdo-notes-filter-options-container">
          <div style="position: relative; margin-top: 1px;" data-cy="tdo-notes-categories-filter">
            <div style="display: flex; max-width: 284px;" data-cy="tdo-notes-categories-header">
              <span class="tdo-note-info-item" style="font-size: 12px; flex: 1; position: relative; top: 3px; margin-left: 0;" data-cy="tdo-notes-categories-label">Categories</span>
              <app-tdo-notes-multiselect-menu #categoryDropdown tooltip="Categories" type="category" [noteId]="" [selectableItems]="notesCategories" [categoryValues]="storedNoteFilterSettings.notesCategories" (categorySelectionComplete)="onFilterCategoryDropdownSelectionComplete($event)" [dropdownMenuYOffset]="-10" style="height: 20px; position: absolute; right: 0;" data-cy="tdo-notes-categories-dropdown" [isShowAllSelectors]="true"></app-tdo-notes-multiselect-menu>
              <div style="flex-basis: 30px; font-size: 10px; margin-top: 6px; margin-right: 20px; opacity: 0.6; cursor: pointer;" (click)="onFilterCategorySettingsReset()" data-cy="tdo-notes-categories-clear">Clear</div>
            </div>
            <div class="tdo-note-category-pill" style="flex: 1; position: relative; margin-top: 8px; margin-right: 2px; max-width: 300px; height: 46px; max-height: 46px; overflow-y: auto; overflow-x: hidden;" data-cy="tdo-notes-selected-categories">
              @for (category of storedNoteFilterSettings.notesCategories; track category.enumNoteCategoryID) {
                <div data-cy="tdo-notes-selected-category-item">
                  {{category.enumNoteCategory.ItemDisplayValue}}
                </div>
              }
            </div>
          </div>
          <div style="position: relative; margin-top: 6px;" data-cy="tdo-notes-types-filter">
            <div style="display: flex; max-width: 284px;" data-cy="tdo-notes-types-header">
              <span class="tdo-note-info-item" style="font-size: 12px; flex: 1; position: relative; top: 3px; margin-left: 0;" data-cy="tdo-notes-types-label">Types</span>
              <app-tdo-notes-multiselect-menu #typeDropdown tooltip="Types" type="type" [noteId]="" [selectableItems]="notesTypes" [typeValues]="storedNoteFilterSettings.notesTypes" (typeSelectionComplete)="onFilterTypeDropdownSelectionComplete($event)" [dropdownMenuYOffset]="-10" style="height: 20px; position: absolute; right: 0;" data-cy="tdo-notes-types-dropdown"></app-tdo-notes-multiselect-menu>
              <div style="flex-basis: 30px; font-size: 10px; margin-top: 6px; margin-right: 20px; opacity: 0.6; cursor: pointer;" (click)="onFilterTypeSettingsReset()" data-cy="tdo-notes-types-clear">Clear</div>
            </div>
            <div class="tdo-note-type-pill" style="flex: 1; position: relative; margin-top: 8px; margin-right: 2px; max-width: 300px; height: 46px; max-height: 46px; overflow-y: auto; overflow-x: hidden;" data-cy="tdo-notes-selected-types">
              @for (type of storedNoteFilterSettings.notesTypes; track type.enumNoteTypeID) {
                <div data-cy="tdo-notes-selected-type-item">
                  {{type.enumNoteType.ItemDisplayValue}}
                </div>
              }
            </div>
          </div>
        </div>
        <div style="margin-top: 8px" data-cy="tdo-notes-view-options">
          <span style="font-weight: 500; color: white;" data-cy="tdo-notes-view-options-title">View options</span><br/>
          <div class="tdo-notes-filters-checkboxes" style="line-height: 1; background-color: rgba(0,0,0,0.22); border-radius: 6px; color: white; font-size: 12px; padding: 3px 6px 3px 6px; border: 2px solid rgba(0,0,0,0.1);" data-cy="tdo-notes-view-checkboxes">
            <div style="display: flex; margin-top: 7px;" data-cy="tdo-notes-view-mode-checkboxes">
              <mat-checkbox aria-label="Full View" [(ngModel)]="storedNoteFilterSettings.isFullView" (change)="onCheckboxChange($event)" style="position: relative; flex: 1;" data-cy="tdo-notes-full-view-checkbox">Full View</mat-checkbox>
              <mat-checkbox aria-label="Condensed View" [(ngModel)]="storedNoteFilterSettings.isCondensedView" (change)="onCheckboxChange($event)" style="position: relative; flex: 1;" data-cy="tdo-notes-condensed-view-checkbox">Condensed View</mat-checkbox>
            </div>
            <div style="display: flex; height: 20px;" data-cy="tdo-notes-created-checkboxes">
              <mat-checkbox aria-label="Created On" [(ngModel)]="storedNoteFilterSettings.isShowCreatedOn" (change)="onCheckboxChange($event)" style="position: relative; flex: 1;" data-cy="tdo-notes-created-on-checkbox">Show Created On</mat-checkbox>
              <mat-checkbox aria-label="Created By" [(ngModel)]="storedNoteFilterSettings.isShowCreatedBy" (change)="onCheckboxChange($event)" style="position: relative; flex: 1;" data-cy="tdo-notes-created-by-checkbox">Show Created By</mat-checkbox>
            </div>
            <div style="display: flex; margin-top: 1px;" data-cy="tdo-notes-modified-checkboxes">
              <mat-checkbox aria-label="Modified On" [(ngModel)]="storedNoteFilterSettings.isShowModifiedOn" (change)="onCheckboxChange($event)" style="position: relative; flex: 1;" data-cy="tdo-notes-modified-on-checkbox">Show Modified On</mat-checkbox>
              <mat-checkbox aria-label="Modified By" [(ngModel)]="storedNoteFilterSettings.isShowModifiedBy" (change)="onCheckboxChange($event)" style="position: relative; flex: 1;" data-cy="tdo-notes-modified-by-checkbox">Show Modified By</mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  END FILTER DROPDOWN-->
    <div class="tdo-notes-header" data-cy="tdo-notes-header">
      <div (click)="onExpandNotes()" style="color: var(--tdo-primary-accent); margin-right: 4px; cursor: pointer;" matTooltip="Open all notes in new window." data-cy="tdo-notes-expand-button"><lucide-icon name="external-link" [size]="20"></lucide-icon></div>
      <div style="flex: 1;" data-cy="tdo-notes-title">
        Notes ({{filteredNotes?.length}})
      </div>
      <div class="tdo-notes-controls" data-cy="tdo-notes-controls">
        <div [matBadge]="alertNotes.length.toString()" [matBadgeDisabled]="alertNotes.length === 0" matBadgeSize="small" matBadgeColor="warn"
          [ngStyle]="{'color': storedNoteFilterSettings.isShowAlertNotes ? 'red' : '#cccccc'}"
          [matTooltip]="storedNoteFilterSettings.isShowAlertNotes ? 'Hide alert notes' : 'Show alert notes'"
          (click)="onEmergencyInformationClick()" data-cy="tdo-notes-alert-toggle">
          <lucide-icon name="alert-circle" [size]="20" style="flex: 1;"></lucide-icon>
        </div>
        <div
          [ngStyle]="{'color': !isShowModuleSpecificNotes ? 'var(--tdo-primary-accent)' : '#cccccc'}"
          [matTooltip]="isShowModuleSpecificNotes ? 'Showing module specific notes for patient' : 'Showing all notes for patient'"
          (click)="onNoteVisibilityClick()" data-cy="tdo-notes-visibility-toggle">
          @if (isShowModuleSpecificNotes) {
            <lucide-icon name="blocks" [size]="20" data-cy="tdo-notes-visibility-off-icon"></lucide-icon>
          }
          @if (!isShowModuleSpecificNotes) {
            <lucide-icon name="layout-grid" [size]="20" data-cy="tdo-notes-visibility-on-icon"></lucide-icon>
          }
        </div>
        <div (click)="onToggleHideExtraInfo()"
          [ngStyle]="{'color': storedNoteFilterSettings.isHideExtraInfo ? 'var(--tdo-primary-accent)' : '#cccccc'}"
          [matTooltip]="storedNoteFilterSettings.isHideExtraInfo ? 'Show note details' : 'Hide note details'"
          data-cy="tdo-notes-hide-details-toggle">
          @if (storedNoteFilterSettings.isHideExtraInfo) {
            <lucide-icon name="minimize-2" [size]="20"></lucide-icon>
          }
          @if (!storedNoteFilterSettings.isHideExtraInfo) {
            <lucide-icon name="maximize-2" [size]="20"></lucide-icon>
          }
        </div>
        <div (click)="onSettingsClick()" data-cy="tdo-notes-settings-button">
          <lucide-icon name="filter" [size]="20" style="flex: 1;" matTooltip="Filter"></lucide-icon>
        </div>
        @if (isUserHasRoleToEdit()) {
          <div (click)="onAddNoteClick()" data-cy="tdo-notes-add-button">
            <lucide-icon name="plus-circle" [size]="20" style="flex: 1;" matTooltip="Add note"></lucide-icon>
          </div>
        }
        <div style="margin-left: 20px; color: black; font-weight: 500;" data-cy="tdo-notes-size-controls">
          @if (!isDockedLeft) {
            <lucide-icon name="chevron-right" [size]="20" style="position: absolute; right: -10px;" matTooltip="Collapse Notes" (click)="isMinimized = !isMinimized; uiService.isRightPanelMinimized = !uiService.isRightPanelMinimized" data-cy="tdo-notes-collapse-button"></lucide-icon>
          }
          @if (currentSize==='{{notesNormalSize}}px') {
            <span class="material-symbols-outlined" style="margin-right:10px;" matTooltip="Expand the Notes to full size" (click)="toggleSize(notesMaximunSize)" data-cy="tdo-notes-full-size-button">
              keyboard_double_arrow_left
            </span>
          }
          @if (currentSize==='{{notesMaximunSize}}px') {
            <span class="material-symbols-outlined" style="margin-right:10px;" matTooltip="Collapse the Notes to medium size" (click)="toggleSize(notesNormalSize)" data-cy="tdo-notes-medium-size-button">
              keyboard_double_arrow_right
            </span>
          }
        </div>
      </div>
    </div>
    <div style="height: 100%; overflow-y: auto;" data-cy="tdo-notes-content">
      <!--    ALERT NOTES-->
      @if (storedNoteFilterSettings.isShowAlertNotes) {
        @for (note of alertNotes; track note.NoteId || $index; let i = $index) {
          <app-tdo-note
            (noteChange)="onNoteChange($event)"
            [autoSaveMsDelay]="autoSaveMsDelay"
            [noteQueryModel]="lastQueryModel"
            [isLastItem]="i == alertNotes.length - 1"
            [storedNoteFilterSettings]="storedNoteFilterSettings"
            [note]="note"
            [notesCategories]="notesCategories"
            [notesTypes]="notesTypes"
            data-cy="tdo-notes-alert-note">
          </app-tdo-note>
        }
      }
      @if (!isLoading) {
        @for (note of filteredNotes; track note.NoteId || $index; let i = $index) {
          <app-tdo-note
            (noteChange)="onNoteChange($event)"
            [autoSaveMsDelay]="autoSaveMsDelay"
            [noteQueryModel]="lastQueryModel"
            [isLastItem]="i == filteredNotes.length - 1"
            [storedNoteFilterSettings]="storedNoteFilterSettings"
            [note]="note"
            [notesCategories]="notesCategories"
            [notesTypes]="notesTypes"
            data-cy="tdo-notes-regular-note">
          </app-tdo-note>
        }
      }
    </div>
  </div>
}
